import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import {
  ANALYTICS,
  FINANCIAL_BRANCH_INDICATOR_REPORT,
  FINANCIAL_DETAILS_OF_EXPENSES_REPORT,
  FINANCIAL_EXPENSE_BY_ARTICLES_REPORT,
  FINANCIAL_FACT_IMPL_REPORT,
  FINANCIAL_INCOMES_REPORT,
  FINANCIAL_PNL_REPORT,
  RIGHTS_ANALYTICS,
  RIGHTS_IS_ON,
  RIGHTS_SALARIES,
} from '@app/constants';
import { useAccessRights } from '@app/hooks';
import { getTabsData } from '@app/pages/Analytics/AnalyticsLayout/utils';

export const useAnalyticsLayout = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { hasUserRight: hasUserRightToIncomesReport } = useAccessRights(
    RIGHTS_ANALYTICS,
    FINANCIAL_INCOMES_REPORT
  );
  const { hasUserRight: hasUserRightToFactImplReport } = useAccessRights(
    RIGHTS_ANALYTICS,
    FINANCIAL_FACT_IMPL_REPORT
  );
  const { hasUserRight: hasUserRightToExpenseByArticlesReport } =
    useAccessRights(RIGHTS_ANALYTICS, FINANCIAL_EXPENSE_BY_ARTICLES_REPORT);
  const { hasUserRight: hasUserRightToPnlReport } = useAccessRights(
    RIGHTS_ANALYTICS,
    FINANCIAL_PNL_REPORT
  );
  const { hasUserRight: hasUserRightToDetailsOfExpensesReport } =
    useAccessRights(RIGHTS_ANALYTICS, FINANCIAL_DETAILS_OF_EXPENSES_REPORT);
  const { hasUserRight: hasUserRightToFinancialBranchIndicatorReport } =
    useAccessRights(RIGHTS_ANALYTICS, FINANCIAL_BRANCH_INDICATOR_REPORT);
  const { hasUserRight: hasUserRightToSalary } = useAccessRights(
    RIGHTS_SALARIES,
    RIGHTS_IS_ON
  );

  const activeTab = searchParams.get('tab');
  const onTabChange = (key: string) => {
    setSearchParams({ tab: key });
  };

  const analyticsTabs = getTabsData({
    hasUserRightToIncomesReport,
    hasUserRightToFactImplReport,
    hasUserRightToExpenseByArticlesReport,
    hasUserRightToPnlReport,
    hasUserRightToDetailsOfExpensesReport,
    hasUserRightToFinancialBranchIndicatorReport,
    hasUserRightToSalary,
  });

  useEffect(() => {
    if (!analyticsTabs?.some((tab) => tab.key === activeTab)) {
      setSearchParams({ tab: ANALYTICS });
    }
  }, [activeTab, analyticsTabs, setSearchParams]);

  return {
    activeTab,
    onTabChange,
    analyticsTabs,
  };
};
